import { MailOutlined } from '@ant-design/icons';
import { Alert, Button, Divider, Form, Input, Typography } from 'antd';

export default function AccountInformationStep({ form, oidcError, oidcLoading, onOidcSignIn, onSignIn }) {
  return (
    <div className="onboarding-account-information">
      <Form form={form} layout="vertical" className="onboarding-account-form">
        <section className="onboarding-account-section">
          <header><MailOutlined /><div><strong>Administrator Access</strong><span>Enter a work email for account activation or continue with Google.</span></div></header>
          {oidcError ? <Alert showIcon type="error" message={oidcError} /> : null}
          <Form.Item
            label="Work Email"
            name="adminEmail"
            extra="We'll send an activation link to this work email."
            rules={[{ required: true, message: 'Enter your work email.' }, { type: 'email', message: 'Enter a valid work email address.' }]}
          >
            <Input prefix={<MailOutlined />} type="email" placeholder="you@company.com" maxLength={160} />
          </Form.Item>
          <Divider plain>or</Divider>
          <Button block size="large" loading={oidcLoading} onClick={onOidcSignIn}>
            {!oidcLoading ? <span className="google-mark" aria-hidden="true">G</span> : null}
            Continue with Google
          </Button>
        </section>
      </Form>
      <div className="onboarding-existing-user">
        <Typography.Text type="secondary">Already have an account?</Typography.Text>
        <Button type="link" onClick={onSignIn}>Sign in</Button>
      </div>
    </div>
  );
}
